import Router, { Route } from 'preact-router';
import { OrderList } from './pages/OrderList';
import { OrderDetail } from './pages/OrderDetail';
import { ItemDetail } from './pages/ItemDetail';

export function App() {
  return (
    <div class="min-h-screen">
      <header class="bg-white shadow-sm border-b">
        <div class="max-w-6xl mx-auto px-4 py-4">
          <a href="/" class="site-logo">
            Nameframe
          </a>
        </div>
      </header>
      <main class="max-w-6xl mx-auto px-4 py-6">
        <Router>
          <Route path="/" component={OrderList} />
          <Route path="/orders/:id" component={OrderDetail} />
          <Route path="/orders/:id/items/:itemIndex" component={ItemDetail} />
        </Router>
      </main>
    </div>
  );
}
